import React from 'react'

const SkeletonChatList = () => {
    const searchInputStyle = {
        width: '100%',
        height: '45px',
        borderRadius: '25px',
        marginBottom: '20px',
    }

    const skeletonItemStyle = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '16px',
    }

    const skeletonDetailsStyle = {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    }

    const skeletonTextLine = (width) => ({
        height: '16px',
        borderRadius: '4px',
        width: width,
        backgroundColor: '#ecebf8',
    })

    return (
        <div className="chat-list-container chat-list-container-active">
            <div style={searchInputStyle} className="animate-pulse bg-lightBG"></div>

            <div className="chat-list no-scroll">
                {Array.from({ length: 6 }).map((_, idx) => (
                    <div className="pl-[39px] pr-[20px] min-h-[91px]" style={skeletonItemStyle} key={idx}>
                        <div className="w-[60px] h-[60px] rounded-full bg-lightBG animate-pulse" />

                        <div style={skeletonDetailsStyle}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className="animate-pulse" style={skeletonTextLine('40%')} />
                                <div className="animate-pulse" style={skeletonTextLine('10%')} />
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className="animate-pulse" style={skeletonTextLine('30%')} />
                                <div className="animate-pulse" style={skeletonTextLine('20%')} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default SkeletonChatList
